import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { B2BUnit } from '@spartacus/core';
import { ItemService, UnitItemService } from '@spartacus/organization/administration/components';
import { Observable } from 'rxjs';
import { switchMap, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-uig-unit-details',
    templateUrl: './uig-unit-details.component.html',
    styleUrls: ['./uig-unit-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigUnitDetailsComponent {
  model$: Observable<B2BUnit> = this.itemService.key$.pipe(
    switchMap((code) => this.itemService.load(code)),
    startWith({})
  );
  isInEditMode$ = this.itemService.isInEditMode$;

  constructor(protected itemService: UnitItemService) {
  }
}
